export default __webpack_public_path__ + "static/about-story-image-f3648895daef5031a13c8d127c4c60cc.webp";